import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { setKpiVendor } from '@api/kpi';

import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';

import { ESnackbarTypes, TVendorsValues } from '@enums/common';

import { SET_KPI_VENDOR, VENDORS_KPI } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSetKpiVendor = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: setDefaultKpiVendor,
		isLoading: isLoadingSetKpiVendor,
	} = useMutation<{ vendor: TVendorsValues }>({
		mutationKey: [SET_KPI_VENDOR],
		mutationFn: ({ vendor }: IVendor) => setKpiVendor({ vendor }),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.defaultVendorChanged,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([VENDORS_KPI]);
		},
	});

	return {
		setDefaultKpiVendor,
		isLoadingSetKpiVendor,
	};
};
